<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card class="shadow-none" v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-for="(item,index) in myList" :key="index">
                    <p v-if="item.type=='<p>'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <drop class="drop" @drop="handleDrop">
                                         <drag class="drag" :transfer-data="{ type:2, content: el.content, i1: index, i2:index2 }" >
                                            <span v-if="(showAns == 0) && (el.content != '')" @click="moveBack(index, index2)" v-bind:style="getStyle(index, index2)"  :id ="getName(index,index2)">{{el.content}}</span>
                                         </drag>
                                        <span v-if="showAns == 1" v-bind:style="getStyle(index, index2)">{{el.answer}}</span>
                                        <span v-if="showAns == 2" v-bind:style="getStyle(index, index2)" >{{el.content}}</span>
                                        <v-icon v-if="showAns == 2 && (myCompare(el.content,el.answer))"  v-bind:style="check_ok" >check_circle</v-icon>  
                                        <v-icon v-if="showAns == 2 && (!myCompare(el.content,el.answer))"  v-bind:style="check_error">error</v-icon>  
                                    </drop>
                                </v-chip>
                                <v-chip v-if="showAns == 2 && (el.content != el.answer)">
                                    <span v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip>
                            </span>
                        </span>
                    </p> 
                    <div id = "mycode" v-if="item.type=='<pre'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <drop class="drop" @drop="handleDrop">
                                         <drag class="drag" :transfer-data="{ type:2, content: el.content, i1: index, i2:index2 }" >
                                            <span v-if="(showAns == 0) && (el.content != '')" @click="moveBack(index, index2)" v-bind:style="getStyle(index, index2)"  :id ="getName(index,index2)">{{el.content}}</span>
                                         </drag>
                                        <span v-if="showAns == 1" v-bind:style="getStyle(index, index2)">{{el.answer}}</span>
                                        <span v-if="showAns == 2" v-bind:style="getStyle(index, index2)" >{{el.content}}</span>
                                        <v-icon v-if="showAns == 2 && (myCompare(el.content,el.answer))"  v-bind:style="check_ok" >check_circle</v-icon>  
                                        <v-icon v-if="showAns == 2 && (!myCompare(el.content,el.answer))"  v-bind:style="check_error">error</v-icon>  
                                    </drop>
                                </v-chip>
                                <v-chip v-if="showAns == 2 && (el.content != el.answer)">
                                    <span v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip>
                            </span>
                        </span>
                    </div>                 
                </div>
                <div>

                </div>
                <v-card>  
                    <v-card-title>Drag&drop or click:</v-card-title>          
                    <v-card-text>
                        <v-chip v-for="(item,index) in offerList" :key="index" @click="moveToFirstFree(index)">
                            <drag class="drag" :transfer-data="{ type:1, content: item, index: index }" >
                                {{item}}
                            </drag>
                        </v-chip> 
                    </v-card-text>
                </v-card>

            </div>

        </v-card>

        <v-card class="shadow-none" v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import { Drag, Drop } from 'vue-drag-drop';

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                fullContent: null,
                showAns: 0, // 0 - user content, 1 - correct content, 2 - check
                myList: [
                    {
                        type: 'p', // p, li
                        list: [
                            {
                                type: 'a', // a, c
                                content : '',
                                answer: '' // correct answer
                            }
                        ]

                    }
                ],
                ignoreSpaces : false,
                aqSome : false,
                check_ok : {
                    color: "green"                    
                },
                check_error : {
                    color: "red"
                },
                correct_answer : {
                    "text-align":"center"
                },
                offerList: []

        }
    },
    components :{
        Drag,
        Drop
    },

    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        moveToFirstFree(index) {
            for(let i = 0; i < this.myList.length; i++) {
                for(let j = 0; j < this.myList[i].list.length; j++) {
                    if (this.myList[i].list[j].content == '___') {
                        this.myList[i].list[j].content = this.offerList[index]
                        this.offerList.splice(index,1)
                        return
                    }
                }
            }            
        },
        moveBack(i1, i2) {
            if (this.myList[i1].list[i2].content != '___') {
                this.offerList.push(this.myList[i1].list[i2].content)
                this.myList[i1].list[i2].content = '___'
            }
        },
        handleDrop(data, event) {
            // target
            var str = event.target.id
            let i1 = str.substring(str.indexOf("#"+1),str.indexOf("_"))
            let i2 = str.substring(str.indexOf("_")+1)  
            
            // data source
            if (data.type == 1 ) {                 
                if (this.myList[i1].list[i2].content != '___') {
                    this.offerList.push(this.myList[i1].list[i2].content)
                    this.offerList.splice(data.index,1)
                    this.myList[i1].list[i2].content = data.content
                } else {
                    this.offerList.splice(data.index,1)
                    this.myList[i1].list[i2].content = data.content
                }
            }

            if (data.type == 2 ) {
                if (this.myList[i1].list[i2].content == '___') {
                    // add to new
                    this.myList[i1].list[i2].content = data.content
                    // delete on old
                    this.myList[data.i1].list[data.i2].content = '___'
                } else { // return target to offer                
                    //this.offerList.push(this.myList[i1].list[i2].content)
                    this.myList[data.i1].list[data.i2].content = this.myList[i1].list[i2].content
                    this.myList[i1].list[i2].content = data.content
                }
            }

        },
        getName(index,index2) {
            return "" + index + "_" + index2
        },
        setBR(line) {
            var start = 0
            while (line.indexOf('\n') > -1) {
                start = line.indexOf('\n')
                if ((start > 0 ) && (start-1, start) != '§') {
                    line = line.substring(0,start) + '<br/>' + line.substring(start+1)
                }
            }
            return line
        },
        parseData(tag,endTag) {
            var mList = []
   
            var start = this.fullContent.indexOf(tag);
            var start2 = 0
            // tili >
            if (tag == '<p>') {
                start2 = start + 2
            } else {
                start2 =  this.fullContent.indexOf('>',start);
            }

            var end = this.fullContent.indexOf(endTag)
            if (start > 0) {
                // content to tag
                mList.push( 
                    {
                      type: 'c',
                      content: this.fullContent.substring(0,start),
                      answer: ''
                    }
                )
            }
            var line = this.fullContent.substring(start2 + 1 , end)
            // change \n to br
            if (tag=='<pre') {
                line = this.setBR(line)
                // spaces at the begin of line
                var spaces = '';
                while (line.indexOf(' ') == 0) {
                    spaces = spaces + '&nbsp;'
                    line = line.substring(1)
                }
                line = spaces + line
                // to last line
                while (line.indexOf('<br/> ') > -1) {
                    start = line.indexOf('<br/> ')
                    line = line.substring(0,start) + '<br/>&nbsp;' + line.substring(start+6)
                }
                while (line.indexOf('&nbsp; ') > -1) {
                    start = line.indexOf('&nbsp; ')
                    line = line.substring(0,start) + '&nbsp;&nbsp;' + line.substring(start+7)
                }
            }
            this.fullContent = this.fullContent.substring(end + endTag.length)

            while (line.indexOf('§§') > -1) {
                start = line.indexOf('§§')
                if (start > 0) {
                    mList.push( 
                        {
                        type: 'c',
                        content: line.substring(0,start),
                        answer: ''
                        }
                    )
                }
                end = line.indexOf('§§',start+1)
                let answ = this.makeNice(line.substring(start+2, end))
                mList.push( 
                    {
                        type: 'a',
                        content: '___',
                        answer: answ
                    }
                )                

                this.offerList.push(answ)
                line = line.substring(end + 2)
                
            }

            // if it is finished by </tag>
            if (line.indexOf(endTag) > 0) {
                line = line.substring(0,line.indexOf(endTag))                    
            }

            if (line.length > 0) {                
                mList.push( 
                    {
                    type: 'c',
                    content: line,
                    answer: ''
                    }
                )
            } 

            this.myList.push( {
                type: tag,
                list: mList
            })

        },
        unSpan(txt) {
            var data = txt
            var start = 0
            var end = 0
            while (data.indexOf('<span') > -1) {
                start = data.indexOf('<span')
                end = data.indexOf('>',start)
                data = data.substring(0,start) + data.substring(end+1)
                start = data.indexOf('</span>')
                data = data.substring(0,start) + data.substring(start+7)
            }
            return data
        },
        initData() {            
            this.needInit = false         
            this.showAns = 0
            this.$store.commit('setFeedback', null)   
            this.myContent = JSON.parse(this.dcontent.data.content)            
            // var globals = this.dcontent.data.globals

            this.myList = []
            this.fullContent = this.myContent.content
            this.offerList = this.myContent.fakes
           
            while (this.fullContent.indexOf('<p>') > -1 || this.fullContent.indexOf('<pre') > -1  ) { 
                if ((this.fullContent.indexOf('<pre') >-1)  && (this.fullContent.indexOf('<p>') >-1)) {
                       if (this.fullContent.indexOf('<pre') > this.fullContent.indexOf('<p>')) {
                         this.parseData('<p>','</p>')       
                       } else {
                         this.parseData('<pre','</pre>')
                       }
                } else {
                    if (this.fullContent.indexOf('<pre') > -1) {
                         this.parseData('<pre','</pre>')   
                    } else {
                        this.parseData('<p>','</p>')      
                    }    
                }
            }      

            // shuffle
            for(let i=0; i < this.offerList.length; i++) {
                const rand = Math.floor(Math.random() * this.offerList.length);
                [this.offerList[i], this.offerList[rand]] = [this.offerList[rand], this.offerList[i]];
            }                        
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.showAns = 2
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            this.showAns = 1
        },
        getStyle(index, index2) {
            if (this.showAns == 0) return { "color":"black",
                                            "text-align":"center"}            
            if (this.showAns == 1) return { 
                                            "text-align":"center"}

            if (this.showAns == 2 && !(this.myCompare(this.myList[index].list[index2].content,this.myList[index].list[index2].answer))) 
                                            return { "background-color":"red",
                                                    "text-align":"center"}
            if (this.showAns == 2 && (this.myCompare(this.myList[index].list[index2].content,this.myList[index].list[index2].answer))) 
                                            return { 
                                                    "text-align":"center"}
        },
        myCompare(a,b) {
            if (a == b) return true
            if (this.ignoreSpaces) {
                a = a.replace(/\s/g, '')
                b = b.replace(/\s/g, '')
                if (a == b) return true
            }                
            if (this.aqSome) {
                while (a.indexOf('"') > -1) a = a.replace('"','\'')
                while (b.indexOf('"') > -1) b = b.replace('"','\'')
            }
            if (a == b) return true
            return false
        },
        makeNice(a) {
            while (a.indexOf('&lt;')>-1) a = a.replace('&lt;','<')
            while (a.indexOf('&gt;')>-1) a = a.replace('&gt;','>')
            while (a.indexOf('&amp;')>-1) a = a.replace('&amp;','&')
            return a
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        },
        resetEvaluatedData() {
  //          this.showFeedback = false
            this.styleObject.color = 'black'
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>

</style>